import React, { useEffect, useState } from "react";
import LoginMpinPassWord from "./LoginMpinPassWord";
import SetNewMpin from "./SetNewMpin";
// import VerifyEmailMobile from './VerifyEmailMobile';
import axios from "../../axios";

export default function ForgotMpinOtp({ studentDetails }) {
  const [emailOtp, setEmailOtp] = useState({
    OtpEnter: null,
    setNewMpin: false,
    backArrow: false,
  });
  const [errorMessage, setErrorMessage] = useState();
  const [isInProgress, setIsInProgress] = useState(false);
  // Here increase the forget email otp time
  const [minutes, setMinutes] = useState(2);
  const [seconds, setSeconds] = useState(60);
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (isClicked) {
      const interval = setInterval(() => {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        }

        if (seconds === 0) {
          if (minutes === 0) {
            clearInterval(interval);
          } else {
            setSeconds(59);
            setMinutes(minutes - 1);
          }
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [seconds, minutes, isClicked]);

  const resendOTP = () => {
    setEmailOtp((prev) => ({ ...prev, OtpEnter: "" }));
    setMinutes(2);
    setSeconds(60);
  };

  function handleOtpChange(e) {
    const value = e.target.value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    setEmailOtp({ OtpEnter: value });
  }

  const handleValidation = async () => {
    setIsInProgress(true);
    try {
      let res;
      if (selectedOption === "option1") {
        res = await axios.post(`studentAuth/validateMobileOtp`, {
          mobile_number: Number(studentDetails?.mobileNumber),
          mobile_otp: emailOtp?.OtpEnter.toString(),
        });
      } else {
        res = await axios.post(`studentAuth/validateEmailOtp`, {
          email_id: studentDetails?.email,
          email_otp: emailOtp?.OtpEnter,
        });
      }
      res && setEmailOtp({ emailOtp, setNewMpin: true });
      setIsInProgress(false);
    } catch (error) {
      setErrorMessage(error?.response?.data?.message);
      setIsInProgress(false);
      console.log(error);
    }
  };

  const handleSendOtp = async () => {
    try {
      setErrorMessage(null);
      setMinutes(2);
      setSeconds(60);
      setIsClicked(true);
      let res;
      if (selectedOption === "option1") {
        await axios.post(`studentAuth/generateMobileOtp`, {
          mobile_number: Number(studentDetails?.mobileNumber),
        });
      } else {
        await axios.post(`studentAuth/generateEmailOtp`, {
          email_id: studentDetails?.email,
        });
      }
      res && resendOTP();
    } catch (error) {
      setErrorMessage("Something went wrong!!!");
      console.log(error);
    }
  };

  const [selectedOption, setSelectedOption] = useState("option2");

  const handleOptionChange = (event) => {
    setEmailOtp((prev) => ({ ...prev, OtpEnter: "" }));
    setIsClicked(false);
    setErrorMessage(null);
    setSelectedOption(event.target.value);
  };

  return (
    <div>
      {!emailOtp.setNewMpin && !emailOtp.backArrow && (
        <div className="ContainerRegister h-100">
          <div className="row">
            <div className="col-md-3 p-0 bannerContainer">
              <img
                className="bannerImg"
                alt="icon"
                src="/LoginRegister/BannerImg.png"
              ></img>
            </div>
            <div className="col-md-9 RegisterDetailContainer">
              <>
                <div
                  className="backLoginIcon"
                  onClick={(e) => setEmailOtp({ ...emailOtp, backArrow: true })}
                >
                  <img src="/LoginRegister/LoginBackIcon.png" alt="icon" />
                </div>
                <form>
                  <div className="InsideDetailCpntainer">
                    <div className="d-flex justify-content-center">
                      <img
                        className="registrationIcon"
                        src="/StudentImg/BreathSchoolLogo.png"
                        alt="icon"
                      />
                    </div>
                    <div className="d-flex justify-content-center headerEnterOtp mt-3">
                      Welcome Back!
                    </div>
                    <div className="OtpEmailId d-flex justify-content-center mt-1">
                      Forgot PIN
                    </div>

                    <div className="d-flex align-items-center mt-2">
                      {/* Here I commented code for hide the mobile otp option */}
                      {/* <label className="mr-3 d-flex align-items-center">
                        <input
                          className="mr-2"
                          type="radio"
                          value="option1"
                          checked={selectedOption === "option1"}
                          onChange={handleOptionChange}
                        />
                        Mobile
                      </label> */}
                      {/* <label className="d-flex align-items-center">
                        <input
                          className="mr-2 inputRadio"
                          type="radio"
                          value="option2"
                          checked={selectedOption === "option2"}
                          onClick={handleOptionChange}
                        />
                        Email
                      </label> */}
                    </div>
                    <div className="d-flex justify-content-between p-3 align-items-center registrationInput">
                      <input
                        id="otpInput"
                        type="text"
                        value={
                          selectedOption === "option1"
                            ? "+91-" + studentDetails?.mobileNumber
                            : studentDetails?.email
                        }
                      />
                    </div>
                    <div className="d-flex justify-content-between p-3 align-items-center registrationInput  mt-4">
                      <input
                        id="otpInput"
                        type="text"
                        maxLength="6"
                        pattern="[0-9]*"
                        value={emailOtp.OtpEnter}
                        onChange={handleOtpChange}
                        placeholder="Enter OTP"
                        autoComplete="off"
                      />
                      {!isClicked ? (
                        <span
                          className="w-25 ml-5 getOtp"
                          onClick={handleSendOtp}
                        >
                          Get OTP
                        </span>
                      ) : (
                        <span className="otp_timer_count">
                          {minutes < 10 ? `0${minutes}` : minutes}:
                          {seconds < 10 ? `0${seconds}` : seconds}
                        </span>
                      )}
                    </div>
                    <div className="d-flex justify-content-between mt-3">
                      <div>
                        {minutes === 0 && seconds === 0 && !errorMessage ? (
                          <div className="invailidOtp ">Time out!</div>
                        ) : (
                          errorMessage === "Invalid OTP." && (
                            <div className="invailidOtp ">
                              invalid OTP entered
                            </div>
                          )
                        )}
                      </div>
                      <div className="d-flex justify-content-end ">
                        <button
                          className="Resend_otp_email"
                          disabled={seconds > 0 || minutes > 0}
                          style={{
                            color:
                              seconds > 0 || minutes > 0
                                ? "#DFE3E8"
                                : "#F77F00",
                            borderBottom: seconds > 0 || minutes > 0
                              ? "1px solid #DFE3E8"
                              : "1px solid #F77F00",
                          }}
                          onClick={handleSendOtp}
                        >
                          Resend OTP
                        </button>
                      </div>
                    </div>
                    <div className="d-flex flex-column justify-content-center mt-2">
                      <button
                        type="submit"
                        // I added && minutes === 0 for enable Proceed button
                        disabled={!emailOtp.OtpEnter || isInProgress || seconds === 0 && minutes === 0}
                        onClick={handleValidation}
                        className="RegisterBtn2"
                      >
                        Proceed
                      </button>
                      {/* {errorMessage && (
                        <span className="align-self-center">
                          {errorMessage}
                        </span>
                      )} */}
                    </div>
                  </div>
                </form>
              </>
            </div>
          </div>
        </div>
      )}

      {emailOtp.backArrow && (
        <LoginMpinPassWord studentDetails={studentDetails} />
      )}
      {emailOtp.setNewMpin && (
        <SetNewMpin
          studentDetails={studentDetails}
          setEmailOtp={setEmailOtp}
          setMinutes={setMinutes}
          setSeconds={setSeconds}
          setIsClicked={setIsClicked}
        />
      )}
    </div>
  );
}
